// @ts-nocheck -- will be removed once we migrate to React
import { next } from '@ember/runloop';
import Service, { service } from '@ember/service';

import window from 'ember-window-mock';

/**
 * Segment manager
 *
 * @class Segment Manager
 * @module qonto/services/segment
 * @extends Ember.Service
 */
export default class Segment extends Service {
  @service metrics;

  /**
   * Identify the user for segment
   *
   * @public
   * @method identify
   *
   * @param  {Object} params
   * @returns void
   */
  identify(params) {
    next(this.metrics, 'identify', 'Segment', { ...params });
  }

  /**
   * Send a custom event to Segment
   *
   * @public
   * @method track
   *
   * @param  {String} eventName Name of the event sent to segment
   * @param  {Object} [params={}]
   *
   * @returns void
   */
  track(eventName, params = {}) {
    next(this.metrics, 'trackEvent', 'Segment', { event: eventName, ...params });
  }

  /**
   * Attach a user to a group
   *
   * @public
   * @method group
   * @param  {Object} params
   *
   * @returns void
   */
  group(params) {
    let canUseDOM = Boolean(
      typeof window !== 'undefined' && window.document && window.document.createElement
    );
    let { groupId } = params;
    delete params.groupId;

    next(() => {
      if (canUseDOM && window.analytics) {
        window.analytics.group(groupId, params);
      }
    });
  }

  /**
   * Reset
   *
   * @public
   * @method reset
   * @returns void
   */
  reset() {
    let canUseDOM = Boolean(
      typeof window !== 'undefined' && window.document && window.document.createElement
    );

    next(() => {
      if (canUseDOM && window.analytics) {
        window.analytics.reset();
      }
    });
  }
}

declare module '@ember/service' {
  interface Registry {
    segment: Segment;
  }
}
